// Project Imports
import axiosInstance from 'providers/axiosInstance/axiosInstance';

type CreateParams = {
  apiUrl: string;
  resource: string;
  variables: Record<string, unknown>;
  meta?: any;
};

const create = async ({ resource, variables, apiUrl, meta }: CreateParams) => {
  const metaFilter = meta;
  console.log(metaFilter, 'metaFilter');
  let url;
  if (metaFilter?.isbackSlash === false) {
    url = `${apiUrl}/${resource}`;
  } else {
    url = `${apiUrl}/${resource}/`;
  }

  // Prepare axios config, including responseType if present in meta
  const axiosConfig: any = {};
  if (metaFilter?.responseType) {
    axiosConfig.responseType = metaFilter?.responseType;
  }

  const response = await axiosInstance.post(url, variables, axiosConfig);

  // If responseType is set, return the whole esponse (for headers, etc.), else just data
  if (metaFilter?.responseType) {
    return response;
  }

  return {
    data: response.data,
  };
};

export default create;
